import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { AddToCart } from '@grandvisionhq/carts-v2';
import { MediaQuery, Price, Button } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';

const CTAButton = ({ onPrescriptionClick , handleMiniCartChange , isPrescriptionEnabled , isCLBBSubscription , calculatedDiscountPrice , calculatedPrice , lineItemsForCart , excludedFromCheckout , hasLenses , onClick , pricePerMonth , renderAddToCartButton , handleConversionEvent ,  })=>{
    const { getLabel , currency  } = useIntl();
    const { routes  } = useProductDetailContext();
    const storesRoute = routes.stores;
    const addToCartCallback = React.useCallback(()=>{
        handleMiniCartChange && handleMiniCartChange();
        onClick && onClick();
    }, [
        handleMiniCartChange,
        onClick
    ]);
    const isPhone = MediaQuery.useIsPhone();
    const buttonSize = isPhone ? 'small' : 'medium';
    /*
   * If CLBB subscription product and configuration is valid, show button with monthly costs that triggers the MiniCart
   * */ if (isCLBBSubscription && hasLenses) {
        const caption = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "body"
        }, getLabel('products.actions.addToCart')), pricePerMonth && /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "body",
            className: "product-detail__add-to-cart"
        }, '(', /*#__PURE__*/ React.createElement(Price, {
            value: pricePerMonth.centAmount,
            currency: currency,
            centAmount: true
        }), ' / ', getLabel('common.frequency.perMonth'), ')'));
        const addToCartProps = {
            'data-t': 'btn-subscription',
            caption,
            onSuccess: addToCartCallback,
            lineItemDrafts: lineItemsForCart.map(({ sku , quantity , custom , customAttributes  })=>({
                    sku,
                    quantity,
                    type: 'contact-lenses-bundle-benelux',
                    typeDetails: swcHelpers.objectSpread({}, custom, customAttributes)
                })
            )
        };
        return renderAddToCartButton ? renderAddToCartButton(addToCartProps) : /*#__PURE__*/ React.createElement(AddToCart, swcHelpers.extends({}, addToCartProps));
    }
    if (isPrescriptionEnabled && hasLenses) {
        const caption = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "body"
        }, getLabel('products.actions.addToCart')), /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "body",
            className: "product-detail__add-to-cart"
        }, /*#__PURE__*/ React.createElement(Price, {
            value: calculatedDiscountPrice ? calculatedDiscountPrice : calculatedPrice,
            currency: currency,
            centAmount: true
        })));
        const addToCartProps = {
            caption,
            onSuccess: addToCartCallback,
            lineItemDrafts: lineItemsForCart.map(({ sku , quantity , custom , customAttributes  })=>({
                    sku,
                    quantity,
                    type: 'contact-lenses',
                    typeDetails: swcHelpers.objectSpread({}, custom, customAttributes)
                })
            )
        };
        return renderAddToCartButton ? renderAddToCartButton(addToCartProps) : /*#__PURE__*/ React.createElement(AddToCart, swcHelpers.extends({}, addToCartProps));
    }
    if (excludedFromCheckout) {
        return /*#__PURE__*/ React.createElement(Button, {
            size: buttonSize,
            caption: getLabel('products.actions.excludedFromCheckout'),
            "data-t": "btn-excluded-from-checkout",
            href: storesRoute,
            onClick: handleConversionEvent
        });
    }
    if (!isPrescriptionEnabled) {
        return /*#__PURE__*/ React.createElement(Button, {
            size: buttonSize,
            caption: getLabel('products.actions.bookAppointment'),
            href: storesRoute,
            "data-t": "btn-book-appointment",
            onClick: handleConversionEvent
        });
    }
    return /*#__PURE__*/ React.createElement(Button, {
        size: buttonSize,
        className: "add-to-cart",
        caption: getLabel('products.actions.addToCart'),
        "data-t": "btn-enter-prescription",
        onClick: onPrescriptionClick
    });
};

export { CTAButton };
//# sourceMappingURL=CTAButton.js.map
